import { Link } from '@tanstack/react-router'
import { Button } from './ui/button'
import type { AxiosError } from 'axios'
import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { useRouter } from '@tanstack/react-router'
import { useQueryClient } from '@tanstack/react-query'

export default function RootErrorComponent({
  error,
}: {
  error: Error | AxiosError
}) {
  const router = useRouter()
  const queryClient = useQueryClient()
  const errorCode = 'code' in error ? error.code : error.name
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  const handleRefresh = () => {
    router.invalidate()
    queryClient.clear()
    window.location.reload()
  }

  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <div className="flex max-w-xl flex-col items-center justify-center gap-4">
        <h1 className="text-2xl">Application Error</h1>
        <p className="text-copy-secondary text-sm">
          An error occurred while loading the application. Please try again or
          contact support.
        </p>
        <span>Error: {errorCode}</span>
        <code>{error.message}</code>
        <div className="flex flex-row items-center gap-2">
          <Button variant="ghost" onClick={() => window.history.back()}>
            Go Back
          </Button>
          <Button variant="ghost" onClick={handleRefresh}>
            Refresh
          </Button>
        </div>
        <Button
          variant="ghost"
          className="text-destructive hover:text-destructive"
          asChild
        >
          <Link to="/logout">Log Out</Link>
        </Button>
      </div>
    </div>
  )
}
